import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import camelCase from 'lodash.camelcase'
import { theme, icons } from '../../constants'

const Icon = forwardRef(function Icon(props, ref) {
	const { children = 'question', size = 1, sizeInPx = false, color: colorProp, ...other } = props

	const iconSize = sizeInPx ? size : `${size}em`
	const color = theme.colors[colorProp] || 'currentColor'

	return (
		<svg ref={ref} width={iconSize} height={iconSize} viewBox="0 0 1024 1024" fill={color} {...other}>
			{typeof children === 'string' ? (
				Array.isArray(icons[camelCase(children)]) ? (
					icons[camelCase(children)].map((path, key) => <path d={path} key={key}></path>)
				) : (
					<path d={icons[camelCase(children)]}></path>
				)
			) : (
				<>{children}</>
			)}
		</svg>
	)
})

export default Icon

Icon.propTypes = {
	/**
	 * A string containing the name of the icon.
	 */
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

	/**
	 * Size value of the icon.
	 * @default 1
	 */
	size: PropTypes.number,

	/**
	 * If true, size defined is in PX. Otherwise, is in em.
	 * @default false
	 */
	sizeInPx: PropTypes.bool,

	/**
	 * Icon color. If null, it inherits the color.
	 * @default null
	 */
	color: PropTypes.oneOf(Object.keys(theme.colors))
}
